/* eslint-disable no-unused-vars */
import { IconButton, InputAdornment, Menu, MenuItem, Tooltip, } from '@material-ui/core';
import { Visibility } from '@material-ui/icons';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import FilterListIcon from '@material-ui/icons/FilterList';
import FindReplaceOutlinedIcon from '@material-ui/icons/FindReplaceOutlined';
import React, { useState } from 'react';
import { ButtonWrapper } from '../ContactListMainView.Styles';
import { CustomTextField, GridWrapper, ListItemWrapper, TitleWrapper, Wrapper, } from './ContactListTable.Styles';
import { isBaseURLAll } from '../../../../api/utils';
import ReactAGGrid from '../../../commons/ReactAGGrid';
var EditButtons = function (_a) {
    var onEditClick = _a.onEditClick, onCopyClick = _a.onCopyClick, onViewClick = _a.onViewClick, onDeleteClick = _a.onDeleteClick, openSidebar = _a.openSidebar;
    return (React.createElement(ListItemWrapper, null,
        React.createElement("div", { style: { cursor: 'pointer' } },
            React.createElement(Tooltip, { title: 'Edit', placement: 'top' },
                React.createElement(IconButton, { disabled: openSidebar, onClick: function () {
                        onEditClick();
                    } },
                    React.createElement(EditOutlinedIcon, null))),
            React.createElement(Tooltip, { title: 'Copy', placement: 'top' },
                React.createElement(IconButton, { disabled: openSidebar, onClick: function () {
                        onCopyClick();
                    } },
                    React.createElement(FindReplaceOutlinedIcon, null))),
            React.createElement(Tooltip, { title: 'View', placement: 'top' },
                React.createElement(IconButton, { disabled: openSidebar, onClick: function () {
                        onViewClick();
                    } },
                    React.createElement(Visibility, null))),
            React.createElement(Tooltip, { title: 'Delete', placement: 'top' },
                React.createElement(IconButton, { disabled: openSidebar, onClick: function () {
                        onDeleteClick();
                    } },
                    React.createElement(DeleteOutlineOutlinedIcon, null))))));
};
export var ContactListTable = function (_a) {
    var onRowDoubleClick = _a.onRowDoubleClick, deleteRow = _a.deleteRow, viewRow = _a.viewRow, rowData = _a.rowData, openSidebar = _a.openSidebar;
    var _b = useState(null), filterAnchor = _b[0], setFilterAnchor = _b[1];
    var _c = useState('Contact List Name'), filterName = _c[0], setFilterName = _c[1];
    var _d = useState(''), filterTarget = _d[0], setFilterTarget = _d[1];
    var handleFilterMenu = function (event) {
        setFilterAnchor(event.currentTarget);
    };
    var handleCloseFilter = function () {
        setFilterAnchor(null);
    };
    var eventFilter = function (filterMode) {
        var lowerTarget = filterTarget.toLowerCase();
        switch (filterMode) {
            case 'Contact List Name':
                return rowData === null || rowData === void 0 ? void 0 : rowData.filter(function (event) {
                    var _a;
                    return (((_a = event === null || event === void 0 ? void 0 : event.ContactListConfigName) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(lowerTarget)) !==
                        -1);
                });
            case 'Contact List Table':
                return rowData === null || rowData === void 0 ? void 0 : rowData.filter(function (event) {
                    var _a;
                    return (((_a = event === null || event === void 0 ? void 0 : event.ContactListTable) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(lowerTarget)) !== -1);
                });
            case 'Phone List Table':
                return rowData === null || rowData === void 0 ? void 0 : rowData.filter(function (event) {
                    var _a;
                    return (((_a = event === null || event === void 0 ? void 0 : event.PhoneListTable) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(lowerTarget)) !== -1);
                });
            case 'DNC Table':
                return rowData === null || rowData === void 0 ? void 0 : rowData.filter(function (event) {
                    var _a;
                    return ((_a = event === null || event === void 0 ? void 0 : event.DncTable) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(lowerTarget)) !== -1;
                });
            case 'DNC Identifier':
                return rowData === null || rowData === void 0 ? void 0 : rowData.filter(function (event) {
                    var _a;
                    return (((_a = event === null || event === void 0 ? void 0 : event.DncIdentifier) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(lowerTarget)) !== -1);
                });
            case 'Daily Call Limit (Record)':
                return rowData === null || rowData === void 0 ? void 0 : rowData.filter(function (event) {
                    var _a, _b;
                    return (((_b = (_a = event === null || event === void 0 ? void 0 : event.Compliance) === null || _a === void 0 ? void 0 : _a.DailyCallLimitRecord) === null || _b === void 0 ? void 0 : _b.toString().toLowerCase().indexOf(lowerTarget)) !== -1);
                });
            case 'Daily Call Limit (Phone)':
                return rowData === null || rowData === void 0 ? void 0 : rowData.filter(function (event) {
                    var _a, _b;
                    return (((_b = (_a = event === null || event === void 0 ? void 0 : event.Compliance) === null || _a === void 0 ? void 0 : _a.DailyCallLimitPhone) === null || _b === void 0 ? void 0 : _b.toString().toLowerCase().indexOf(lowerTarget)) !== -1);
                });
            default:
                return rowData;
        }
    };
    var columns = [
        {
            headerName: 'Account Name',
            field: 'prjacc.name',
            hide: !isBaseURLAll(),
            width: 200
        },
        {
            field: 'id',
            headerName: 'Contact List ID',
            hide: true
        },
        {
            field: 'ContactListConfigName',
            headerName: 'Contact List'
        },
        {
            field: 'ContactListTable',
            headerName: 'Contact List Table'
        },
        {
            field: 'PhoneListTable',
            headerName: 'Phone List Table'
        },
        {
            field: 'DncTable',
            headerName: 'Do Not Call Table'
        },
        {
            field: 'DncIdentifier',
            headerName: 'DNC Identifier'
        },
        {
            field: 'PhoneTypes',
            headerName: 'Phone Types',
            cellRenderer: function (_a) {
                var _b;
                var rowData = _a.data;
                var outputString = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.PhoneTypes) === null || _b === void 0 ? void 0 : _b.toString().replaceAll(',', ', ');
                return outputString != null ? outputString : 'None';
            }
        },
        {
            field: 'Compliance.DailyCallLimitRecord',
            headerName: 'Daily Call Limit (Record)',
            width: 200
        },
        {
            field: 'Compliance.DailyCallLimitPhone',
            headerName: 'Daily Call Limit (Phone)',
            width: 200
        },
    ];
    return (React.createElement(Wrapper, null,
        React.createElement(TitleWrapper, null,
            React.createElement(ButtonWrapper, null,
                React.createElement(CustomTextField, { size: 'small', label: "Filter by " + filterName, placeholder: "Filter by " + filterName, variant: 'outlined', InputProps: {
                        endAdornment: (React.createElement(InputAdornment, { position: 'end' },
                            React.createElement(Tooltip, { title: 'Change Filter Criteria', placement: 'top' },
                                React.createElement(IconButton, { onClick: handleFilterMenu },
                                    React.createElement(FilterListIcon, null)))))
                    }, onChange: function (e) { return setFilterTarget(e.target.value); } }),
                React.createElement(Menu, { id: 'filter-menu', open: Boolean(filterAnchor), keepMounted: true, anchorEl: filterAnchor, onClose: handleCloseFilter },
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Contact List Name');
                        } },
                        "Contact List Name",
                        ' '),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Phone List Table');
                        } }, "Phone List Table"),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Contact List Table');
                        } }, "Contact List Table"),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('DNC Table');
                        } }, "DNC Table"),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('DNC Identifier');
                        } }, "DNC Identifier"),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Daily Call Limit (Record)');
                        } }, "Daily Call Limit (Record)"),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Daily Call Limit (Phone)');
                        } }, "Daily Call Limit (Phone)")))),
        React.createElement(GridWrapper, null,
            React.createElement(ReactAGGrid, { name: 'contactList', onRowClicked: function (e) { }, actions: [
                    {
                        icon: function () { return React.createElement(EditOutlinedIcon, null); },
                        tooltip: 'Edit',
                        disabled: openSidebar,
                        onClick: function (event, rowData) {
                            onRowDoubleClick(rowData, true);
                        }
                    },
                    {
                        icon: function () { return React.createElement(FindReplaceOutlinedIcon, null); },
                        tooltip: 'Copy',
                        disabled: openSidebar,
                        onClick: function (event, rowData) {
                            onRowDoubleClick(rowData, false);
                        }
                    },
                    {
                        icon: function () { return React.createElement(Visibility, null); },
                        tooltip: 'View',
                        disabled: openSidebar,
                        onClick: function (event, rowData) {
                            viewRow(rowData);
                        }
                    },
                    {
                        icon: function () { return React.createElement(DeleteOutlineOutlinedIcon, null); },
                        tooltip: 'Delete',
                        disabled: openSidebar,
                        onClick: function (event, rowData) {
                            deleteRow(rowData.id);
                        }
                    },
                ], columns: columns, rows: eventFilter(filterName), autoResize: true }))));
};
ContactListTable.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=ContactListTable.js.map